import { useQueries, useQuery } from "@tanstack/react-query";
import { insuranceAnalysisService } from "../../services/insurance_data/InsuranceAnalysisService";

export const useHealthCoverageAnalysis = (contactId: number | null, enabled = false) =>
  useQuery({
    queryKey: ["healthCoverageAnalysis", contactId],
    queryFn: () => insuranceAnalysisService.analyzeHealthCoverage(contactId!),
    enabled: enabled && contactId != null,
    staleTime: 30_000,
  });

export const useHealthCoverageAnalysisMulti = (contactIds: number[]) =>
  useQueries({
    queries: contactIds.map((id) => ({
      queryKey: ["healthCoverageAnalysis", id],
      queryFn: () => insuranceAnalysisService.analyzeHealthCoverage(id),
      enabled: id != null,
      staleTime: 30_000,
    })),
  });
